import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core'
import { FieldType } from '@ngx-formly/core'
import { MultiSelect } from 'primeng/multiselect'
import { Observable, Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

@Component({
  selector: 'basin-formly-multiselect',
  templateUrl: './formly-multiselect.component.html',
  styleUrls: ['./formly-multiselect.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyMultiselectComponent
  extends FieldType
  implements OnInit, OnDestroy
{
  @ViewChild('multi') multi: MultiSelect
  private ngUnsubscribe = new Subject<void>()

  ngOnInit(): void {
    this.startUp()
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }

  startUp(): void {
    if (this.props && this.props.initialize) {
      this.setModel()
    }
    this.formControl.valueChanges.subscribe((value) => {
      this.props.valueChanges && this.props.valueChanges(value)
    })
  }

  checkIfObservable(options: Observable<any[]> | any[]) {
    return options instanceof Observable
  }

  setModel(): void {
    ;(this.props.options as Observable<any>)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result) => {
        if (result) {
          const initialySelected = result
            .filter(
              (option) =>
                option.selected === undefined ||
                (option.selected !== undefined && option.selected)
            )
            .map((option) => option[this.props.valueProp])

          this.formControl.setValue(initialySelected)
          this.options.updateInitialValue()
        }
      })
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Home' || event.key === 'End') {
      event.stopPropagation()
    }
  }
}
